export default "__VITE_ASSET__c7728394__"